import React from "react";
import PropTypes from "prop-types";
import { parse } from "qs";

import { STREAM_TYPE, DEFAULT_CARD_HEIGHT } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";
import FullStoryCard from "cards/containers/FullStoryCard";
import SectionStreamHelmet from "stream/components/SectionStreamHelmet";
import { getLastSeenCookie } from "stream/utils/lastSeenCookie";
import Ad from "components/Library/Ad";

class SectionStream extends React.Component {
  render() {
    const streamParams = {
      lookup: this.props.slug,
      type: STREAM_TYPE.SECTION,
      lastSeenId: getLastSeenCookie({
        lookup: this.props.slug,
        type: STREAM_TYPE.SECTION,
      }),
    };

    const parsedQs = parse(this.props.location.search.slice(1));

    return (
      <React.Fragment>
        <SectionStreamHelmet slug={streamParams.lookup} />
        <StandardLayout
          main={(
            <React.Fragment>
              {/* Display ad first in stream if queryparam exists */}
              {parsedQs.adid && (
                <Ad
                  slotSize="fluid"
                  renderWhenViewable={false}
                  collapseEmptyDiv={true}
                  targeting={{ adid: parsedQs.adid }}
                />
              )}
              <Stream
                {...streamParams}
                defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD} 
                contentComponent={FullStoryCard}
              />
            </React.Fragment>
          )}
          complementary={(
            <LatestStories />
          )}
        />
      </React.Fragment>
    );
  }
}

SectionStream.propTypes = {
  slug: PropTypes.string.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};


export default SectionStream;
